module.exports = __webpack_public_path__ + "img/thumb.a7f04526.png";